import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=51a823a2&scoped=true&"
import script from "./Test.vue?vue&type=script&lang=ts&"
export * from "./Test.vue?vue&type=script&lang=ts&"
import style0 from "./Test.vue?vue&type=style&index=0&id=51a823a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a823a2",
  null
  
)

export default component.exports